import React from 'react';
import { Box, Flex } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { SidebarItem as SidebarItemComponent } from './SidebarItem';
import { SidebarItem, SidebarLink, DIVIDER } from './types';

interface SidebarProps {
  links: SidebarItem[];
  activeUrl: string;
  fullWidth?: boolean;
  onItemSelect?: () => void;
}

export function Sidebar({ links, activeUrl, fullWidth, onItemSelect }: SidebarProps) {
  const cq = useContainerQuery();
  const sidebarWidth = cq({ base: 170, md: 200, lg: 220, xl: 240 });

  const widthProps = fullWidth
    ? { w: '100%', style: { flex: 1 } }
    : { w: sidebarWidth, miw: sidebarWidth };

  return (
    <Box {...widthProps} data-testid="sidebar">
      <Flex direction="column" gap={cq({ base: 'xxs', xl: 'xs' })}>
        {links.map((item, index) => (
          <SidebarItemComponent
            key={item === DIVIDER ? `divider-${index}` : (item as SidebarLink).href}
            item={item}
            activeUrl={activeUrl}
            onSelect={onItemSelect}
          />
        ))}
      </Flex>
    </Box>
  );
}
